import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { always, applySpec } from 'ramda';

import { GenericPayloadType, GenericStateType } from '@ezugi/types';

import {
  LOW_BALANCE_DIALOG,
  DISCONNECTED_SESSION_DIALOG,
  DISCONNECTED_FOR_INACTIVITY_DIALOG,
  TABLE_CLOSED_DIALOG,
} from '../constants/dialog';

const errorDialogs = [
  LOW_BALANCE_DIALOG,
  DISCONNECTED_SESSION_DIALOG,
  DISCONNECTED_FOR_INACTIVITY_DIALOG,
  TABLE_CLOSED_DIALOG,
];

const getSoundName = ({ name }: {name?: string} = {}) => (name && errorDialogs.includes(name) ? 'error' : null);

type DialogAddPayload = GenericPayloadType;

type GenericDialogButton = {
  action: string;
  props: {
    label: string;
    accent?: boolean;
  }
}

type GenericDialogState = {
  name: 'GenericDialog';
  type?: string;
  data?: GenericStateType;
  html?: string;
  className?: string;
  buttons: GenericDialogButton[];
}

type DialogState = GenericDialogState | {
  name?: string;
  type?: string;
  data?: GenericStateType;
  html?: string;
  title?: string;
  message?: string;
  className?: string;
  description?: string;
  closeTimer?: number | null;
}

const initialState : DialogState = {};

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    add: {
      reducer(_state, { payload }: PayloadAction<DialogAddPayload>,) {
        return payload;
      },
      prepare(payload: DialogAddPayload) {
        const meta = applySpec({
          spriteName: always('base_sprite'),
          soundName: getSoundName,
        })(payload);

        return { payload, meta };
      },
    },
    remove(_state) {
      return initialState;
    },
  },
});

export const dialogActions = dialogSlice.actions;
export default dialogSlice.reducer;
